import Http, { paramsSerializer } from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async list(params) {
        params._method = 'GET'
        return to(Http.post(window.API_PREFIX + "/users", { ...params, paramsSerializer }))
    },
    async get(id) {
        return to(Http.get(window.API_PREFIX + `/users/${id}`))
    },
    async getSelect(params = {}) {
        return this.list({ _type : "select", ...params })
    },
    async store(data) {
        return to(Http.post(window.API_PREFIX + `/users`, data))
    },
    async update(id, data) {
        data.append("_method", "patch");
        return to(Http.post(window.API_PREFIX + `/users/${id}`, data))
    },
    async save(data, id){
        return id ? this.update(id, data) : this.store(data)
    },
    async delete(id) {
        return to(Http.post(window.API_PREFIX + `/users/${id}`, {'_method': 'delete'}))
    },
	async generateQRCode(id) {
		return to(Http(window.API_PREFIX + `/users/${id}/mobile-qrcode`))
	}
}

